._contentFieldsContainer_8ojse_1 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

._newContentField_8ojse_7 {
  display: flex;
  flex-direction: row-reverse;
}